<!-- 各季度农机注册与注销情况统计 -->
<template>
  <div id="BottomSecondChart" :style="{ height: height, width: width }" />
</template>
<script>
import * as echarts from "echarts";
import resize from "@/components/chart/mixins/resize";
let chartVm = null;
function numberFloatSeparatorCompute(number) {
  let num = number;
  if (!number) {
    num = 0;
  }
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
export default {
  mixins: [resize],
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      chart: null,
      monthData: [],
      data1: [],
      data2: [],
      // max: 10,
      options: {
        legend: {
          top: "4px",
          icon: "rect",
          itemWidth: 12, // 图标宽度
          itemHeight: 4, // 图标高度
          right: "16px",
          top: "1",
          selected: {
            hide: false,
          },
          data: [
            {
              name: "注册登记",
              color: "rgba(38, 255, 114, 1)",
            },
            {
              name: "注销",
              color: "rgba(255, 174, 13, 1)",
            },
          ],
          textStyle: {
            color: "#fff",
            fontFamily: "Microsoft YaHei",
            fontSize: 12,
            padding: [2,0,0,0]
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0, 31, 11, 0.4)",
          formatter: function (params) {
            let html = `<div>${params[0].name}</div>`;
            params.forEach((param) => {
              let marker = `<span style="display:inline-block;margin-bottom: 3px;margin-right:5px;width:12px;height:4px;background-color:${param.color}"></span>`;
              html += `${marker} ${
                param.seriesName
              }： ${param.value || 0} 台</br>`; // 示例：添加百分比符号
            });
            return html;
          },
          axisPointer: {
            type: "line",
            lineStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                //渐变色在下面修改，这里是透明度
                [
                  {
                    offset: 0,
                    color: "rgba(0, 255, 132, 0.1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255, 132, 1)",
                  },
                ]
              ),
            },
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(161, 207, 219, 0.15)",
              type: "solid",
            },
          },
          axisLabel: {
            show: true,
            color: "#BABBBD",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            margin: 15,
          },
        },
        yAxis: {
          name: "(台)",
          nameTextStyle: {
            color: "#BABBBD",
            fontSize: 12,
            align: "right",
            padding: [0, 24, 0, 0],
          },
          type: "value",
          min: 0,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "rgba(161, 207, 219, 0.15)",
              type: "solid",
            },
          },
          axisLabel: {
            color: "#BABBBD",
            formatter: "{value}",
            fontSize: 12,
            fontFamily: "MicrosoftYaHei",
          },
        },
        grid: {
          top: "22%",
          left: "18%",
          right: "6%",
          bottom: "22%",
        },
      },
    };
  },
  watch: {
    chartData() {
      this.monthData = this.chartData.map((item) => {
        return item.seasonStr.substring(1);
      });
      this.data1 = this.chartData.map((item) => {
        return item.apply;
      });
      this.data2 = this.chartData.map((item) => {
        return item.logout;
      });
      // this.max = Math.max(...this.data1, ...this.data2);
      // this.max = Math.round(this.max * 1.1);
      this.initChart();
    },
  },
  mounted() {
    this.chartData.map((item) => {
      this.monthData.push(item.seasonStr?.substring(1));
      this.data1.push(item.apply);
      this.data2.push(item.logout);
    });
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  activated() {
    this.$nextTick(function () {
      setTimeout(() => {
        this.chart.resize();
      }, 500);
    });
  },
  methods: {
    setChartData() {
      let series = [];
      let that = this;
      series.push({
        name: "注册登记",
        data: this.data1,
        type: "line",
        smooth: true,
        symbol: "circle",
        symbolSize: 1,
        itemStyle: {
          color: "rgba(38, 255, 114, 1)",
          emphasis: {
            // 悬停状态配置
            color: "#FFFFFF", // 悬停填充色
            borderColor: "rgba(98, 255, 153, 0.2)",
            borderWidth: 6,
            shadowBlur: 6, // 阴影模糊度
            shadowColor: "rgba(98, 255, 153, 1)",
            symbolSize: 10, // 悬停时图标放大
          },
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "rgba(32, 214, 96, 0.05)" },
            { offset: 1, color: "rgba(32, 214, 96, 0.2)" },
          ]),
        },
      });
      series.push({
        name: "注销",
        data: this.data2,
        type: "line",
        smooth: true,
        symbol: "circle",
        symbolSize: 1,
        itemStyle: {
          color: "rgba(255, 174, 13, 1)",
          emphasis: {
            // 悬停状态配置
            color: "#FFFFFF", // 悬停填充色
            borderColor: "rgba(255, 211, 122, 0.2)",
            borderWidth: 6,
            shadowBlur: 10, // 阴影模糊度
            shadowColor: "rgba(255, 211, 122, 1)",
            symbolSize: 10, // 悬停时图标放大
          },
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "rgba(255, 174, 13, 0.05)" },
            { offset: 1, color: "rgba(255, 174, 13, 0.2)" },
          ]),
        },
        color: "#12f4d4",
      });
      this.options.xAxis.data = this.monthData;
      // console.log('this.monthData:::', this.monthData, 'this.options.xAxis.data:::', this.options.xAxis.data)
      // this.options.yAxis.max = this.max;
      this.options.series = series;
      this.chart.setOption(this.options);
    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById("BottomSecondChart"));
      }
      this.setChartData();
    },
  },
};
</script>
